import { supo } from '../api';
import ActionTypes from '../constants/ActionTypes';

export const fetchCategory = id => {
  return async dispatch => {
    if (!id) return;
    try {
      const { data: category } = await supo.get(`/category/${id}`);
      return dispatch({
        type: ActionTypes.FETCH_CATEGORY_SUCCESS,
        payload: category
      });
    } catch (e) {
      return dispatch({
        type: ActionTypes.FETCH_CATEGORY_ERROR,
        payload: { id }
      });
    }
  };
};

export const fetchCategorySuggestions = id => {
  return async dispatch => {
    if (!id) return;
    try {
      const { data: category } = await supo.get(`/category/${id}/suggestions`);
      return dispatch({
        type: ActionTypes.FETCH_CATEGORY_SUGGESTIONS_SUCCESS,
        payload: category
      });
    } catch (e) {
      return dispatch({
        type: ActionTypes.FETCH_CATEGORY_SUGGESTIONS_ERROR,
        payload: { id }
      });
    }
  };
};

export const fetchCategorySuggestionsFromKey = key => {
  return async dispatch => {
    if (!key) return;
    try {
      const { data: category } = await supo.get(`/category/key/${key}/suggestions`);
      return dispatch({
        type: ActionTypes.FETCH_CATEGORY_SUGGESTIONS_SUCCESS,
        payload: category
      });
    } catch (e) {
      return dispatch({
        type: ActionTypes.FETCH_CATEGORY_SUGGESTIONS_ERROR,
        payload: { key }
      });
    }
  };
};

export const fetchCategories = () => {
  return async dispatch => {
    try {
      const { data: categories } = await supo.get(`/categories`);
      return dispatch({
        type: ActionTypes.FETCH_CATEGORIES_SUCCESS,
        payload: categories
      });
    } catch (e) {
      return dispatch({
        type: ActionTypes.FETCH_CATEGORIES_ERROR
      });
    }
  };
};

export const fetchCategoryList = (url: string) => {
  return async dispatch => {
    try {
      const { data: categories } = await supo.get(url);
      return dispatch({
        type: ActionTypes.FETCH_CATEGORY_LIST_SUCCESS,
        payload: { categories, url }
      });
    } catch (e) {
      return dispatch({
        type: ActionTypes.FETCH_CATEGORY_LIST_ERROR,
        payload: { url }
      });
    }
  };
};

export const fetchCategoryFromKey = key => {
  return async dispatch => {
    if (!key) return;
    try {
      const { data: category } = await supo.get(`/category/key/${key}`);
      return dispatch({
        type: ActionTypes.FETCH_CATEGORY_FROM_KEY_SUCCESS,
        payload: category
      });
    } catch (e) {
      return dispatch({
        type: ActionTypes.FETCH_CATEGORY_FROM_KEY_ERROR,
        payload: { key }
      });
    }
  };
};
